import { INewsLetter } from "../templates/NewsLetter/NewsLetter/NewsLetter";
import { IEnrichedNewsLetter } from "../templates/NewsLetter/EnrichedNewsLetter/EnrichedNewsLetter";
import { mockedActivities } from "./activities";
import { mockedSections } from "./sections";

export const newsLetterContent: INewsLetter = {
  joinTitle: "Join Our Newsletter",
  joinDescription: "And get 10% discount for your shopping",
  successTitle: "subscription successful",
  successDescription:
    "We have sent you an email with a promo code for a 10% discount. Also expect a weekly newsletter with new products and inspiring content",
  successImageSrc: "assets/images/subscription-success.svg",
};

export const enrichedNewsLetterContent: IEnrichedNewsLetter = {
  joinTitle: "Join Our Newsletter",
  joinDescription: "And get 10% discount for your shopping",
  successTitle: "subscription successful",
  successDescription:
    "We have sent you an email with a promo code for a 10% discount. Also expect a weekly newsletter with new products and inspiring content",
  successImageSrc: "assets/images/subscription-success.svg",
  sportsSelector: {
    placeholder: "Placeholder",
    label: "Sports that interest you:",
    sports: mockedActivities,
  },
  checkboxGroup: {
    label: "Section that interest you:",
    checkboxes: mockedSections,
  },
};
